import { render, staticRenderFns } from "./JobChannel.vue?vue&type=template&id=4824bbe0&"
import script from "./JobChannel.vue?vue&type=script&lang=js&"
export * from "./JobChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports